export enum EEvent {
  COMPARE_CONTROL_CLICK = 'comparatorClick',
  COMPARATOR_PRODUCTS_CHANGE = 'comparatorProductsChange',
}
